import {
  Globe,
  Briefcase,
  Cloud,
  Activity,
  Languages,
  ShieldCheck,
} from "lucide-react";

const columns = [
  {
    offset: "",
    items: [
      {
        icon: Globe,
        title: "Global Reach",
        description:
          "Seamless multi-jurisdictional compliance across India, Canada, and the USA.",
      },
      {
        icon: Briefcase,
        title: "SME Focused",
        description:
          "We understand the unique constraints and ambitions of growing businesses.",
        indented: true,
      },
    ],
  },
  {
    offset: "md:mt-10",
    items: [
      {
        icon: Cloud,
        title: "Cloud-Based",
        description:
          "Modern tech stack for real-time access to your numbers from anywhere.",
      },
      {
        icon: Activity,
        title: "Real-Time Reporting",
        description:
          "See your financial health live, don't wait for month-end.",
        indented: true,
      },
    ],
  },
  {
    offset: "md:mt-20",
    items: [
      {
        icon: Languages,
        title: "Bilingual",
        description:
          "Effective communication across regions and technical tax requirements.",
      },
      {
        icon: ShieldCheck,
        title: "Secure Data",
        description:
          "Bank-grade encryption and strict privacy protocols for your records.",
        indented: true,
      },
    ],
  },
];


function WhyItem({ icon, title, description, indented = false }) {
  const Icon = icon;
  return (
    <div className={`flex gap-5 `}>
      <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-gold flex items-center justify-center text-white shadow-gold-inset">
        <span className="material-symbols-outlined text-xl">
          <Icon />
        </span>
      </div>
      <div>
        <h4 className="font-manrope text-h3 text-navy mb-1">{title}</h4>
        <p className="font-manrope text-body-sm text-on-surface-variant">{description}</p>
      </div>
    </div>
  );
}

export default function WhyChooseUs() {
  return (
    <section className="py-20 max-w-[1280px] mx-auto px-6">
      <div className="text-center mb-16">
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="h-px w-8 bg-gold" />
          <span className="font-manrope text-label-caps text-gold">WHY GREATCALCY</span>
          <div className="h-px w-8 bg-gold" />
        </div>
        <h2 className="font-manrope text-h1 text-navy">Institutional Agility</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {columns.map((col, i) => (
          <div key={i} className={`flex flex-col gap-10`}>
            {col.items.map((item) => (
              <WhyItem key={item.title} {...item} />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
